import EnumSet from 'Services/enumSet'

interface ISharedSupport extends EnumSet {
  otherTopic: number
}

export const shared = new EnumSet({
  otherTopic: { value: 99, description: 'Quero falar sobre outro assunto' }
}) as ISharedSupport

interface ISupplierSupport extends EnumSet {
  none: number
  updateAccount: number
  subscribePlan: number
  changePlan: number
  accessAccount: number
  buyOpportunity: number
  cantAnounce: number
  makePayment: number
  badSupplier: number
  updateCategories: number
  deleteAnnounce: number
}

export const supplier = new EnumSet({
  updateAccount: { value: 2, description: 'Quero atualizar meu cadastro' },
  subscribePlan: { value: 16, description: 'Tenho dúvidas para assinar um plano' },
  changePlan: { value: 3, description: 'Quero alterar meu plano' },
  changePayment: { value: 15, description: 'Quero alterar minha de forma de pagamento' },
  accessAccount: { value: 1, description: 'Não consigo acessar a conta da empresa' },
  buyOpportunity: { value: 5, description: 'Não consigo comprar uma oportunidade' },
  cantAnounce: { value: 6, description: 'Não encontrei onde anunciar' },
  makePayment: { value: 4, description: 'Tive problemas com pagamento' },
  badSupplier: { value: 7, description: 'Tive problemas com o solicitante' },
  updateCategories: { value: 14, description: 'Quero alterar as especialidades do meu anúncio' },
  updateCities: { value: 20, description: 'Quero alterar a área de atendimento do meu anúncio' },
  deleteAnnounce: { value: 13, description: 'Quero desativar ou excluir meu anúncio' },
}) as ISupplierSupport

interface ICustomerSupport extends EnumSet {
  none: number
  accessAccount: number
  notAnswered: number
  badSupplier: number
  cantFind: number
  deleteAccount: number
}

export const customer = new EnumSet({
  accessAccount: { value: 8, description: 'Não consigo acessar minha conta' },
  notAnswered: { value: 10, description: 'Minha solicitação não foi atendida' },
  badSupplier: { value: 11, description: 'Tive problemas com um fornecedor' },
  cantFind: { value: 9, description: 'Não encontrei o que precisava' },
  deleteAccount: { value: 12, description: 'Quero desativar ou excluir minha conta' }
}) as ICustomerSupport

interface ICancellationReasonSupport extends EnumSet {
  lowIvestmentReturn: number
  costReduction: number
  marketingStrategyChange: number
  changeResponsibleEmployee: number
  ThereIsNoStructureToAnswerCalls: number
  CompanyTemporarilyNotActing: number
  CompanyClosedOrWillNoLongerOperate: number
  CompanyNegotiatingRenewal: number
  DifficultyUsingThePlatform: number
  ServiceOrProductIncompatibleWithThePublic: number
}

export const cancellationReason = new EnumSet({
  lowIvestmentReturn: { value: 1, description: 'Baixo retorno sobre o investimento' },
  costReduction: { value: 2, description: 'Redução de custos' },
  marketingStrategyChange: { value: 3, description: 'Mudança de estratégia de marketing' },
  changeResponsibleEmployee: { value: 4, description: 'Mudança de funcionário responsável' },
  ThereIsNoStructureToAnswerCalls: { value: 5, description: 'Não há estrutura para atender os chamados' },
  CompanyTemporarilyNotActing: { value: 6, description: 'Empresa temporáriamente não atuando' },
  CompanyClosedOrWillNoLongerOperate: { value: 7, description: 'Empresa fechou ou não atuará mais' },
  CompanyNegotiatingRenewal: { value: 8, description: 'Empresa negociando renovação' },
  DifficultyUsingThePlatform: { value: 9, description: 'Dificuldade em usar a plataforma' },
  ServiceOrProductIncompatibleWithThePublic: { value: 10, description: 'Serviço ou produto imcompatível com o público' }
}) as ICancellationReasonSupport

export default {
  shared,
  supplier,
  customer,
}